import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './FeedbackPin.module.scss';

const FeedbackPin = ({ number, x, y, severity, onClick }) => {
  const style = {
    left: `${x}%`,
    top: `${y}%`,
  };

  const content = `# ${number}`;

  if (onClick) {
    return (
      <button
        type="button"
        className={cn(styles.pin, styles[severity], styles['pin-button'])}
        style={style}
        onClick={e => {
          e.stopPropagation();
          onClick();
        }}
        aria-label={`Select feedback ${number}`}
      >
        {content}
      </button>
    );
  }

  return (
    <div className={cn(styles.pin, styles[severity])} style={style}>
      {content}
    </div>
  );
};

FeedbackPin.propTypes = {
  number: PropTypes.number.isRequired,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  severity: PropTypes.string,
  onClick: PropTypes.func,
};

export default FeedbackPin;
